'use strict';

var React = require('react');

var SvgChartHistogramGrowthIcon = function SvgChartHistogramGrowthIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 4.25a.75.75 0 0 0-1.5 0v11.5a.75.75 0 0 0 1.5 0v-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 13.25a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.75a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0v-8Z"
  }));
};
SvgChartHistogramGrowthIcon.displayName = "ChartHistogramGrowthIcon";

exports.SvgChartHistogramGrowthIcon = SvgChartHistogramGrowthIcon;
